import { useFormikContext } from "formik";
import { Checkbox } from "@/core/components/ui/checkbox";
import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography";
import { IBusiness } from "@/business/business";
import { formatMoney } from "@/core/utils/money";
import BusinessInfoPair from "./business-info-pair";

const BusinessPaymentsSettings = ({ isEditMode }: { isEditMode: boolean }) => {
  const { values, setFieldValue } = useFormikContext<Partial<IBusiness>>();

  return (
    <Stack gap="md" className="pb-6" fullWidth>
      <Typography variant="subtitleW2">Payments Settings</Typography>
      <Stack direction="row" gap="lg" fullWidth>
        <BusinessInfoPair
          isEditMode={isEditMode}
          label="Maximum referral payout"
          value={formatMoney(values?.max_payout || 0)}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            setFieldValue("max_payout", numericValue || 0);
          }}
        />
        <Stack gap={isEditMode ? "md" : "sm"} className="size-1/4">
          <Stack direction="row" gap="sm" align="center">
            {isEditMode && (
              <Checkbox
                checked={values.credit_payment_enabled}
                onCheckedChange={(checked) =>
                  setFieldValue("credit_payment_enabled", checked)
                }
              />
            )}
            <Typography variant="subtitleW3" textColor="tertiary">
              Credit bonus available
            </Typography>
          </Stack>
          {isEditMode ? (
            <Typography variant="captionW1" textColor="tertiary">
              Advocates and reps will be informed via email and the business can
              add the credit to their account
            </Typography>
          ) : (
            <Typography variant="bodyW1">
              {values.credit_payment_enabled ? "Yes" : "No"}
            </Typography>
          )}
        </Stack>
        {/* <Stack gap="md" fullWidth>
          <BusinessInfoPair
            // isEditMode={isEditMode} TODO: uncomment when ready
            label="Credit multiplier"
            value={" - "}
          />
          {isEditMode && (
            <Typography variant="captionW1" textColor="tertiary">
              This increases the amount the advocate gets credited when choosing
              credit over a cash payout.{" "}
              <Typography
                variant="captionW1"
                color="secondary"
                onClick={() => {
                  console.log("learn more");
                }}
                className="inline cursor-pointer underline"
              >
                Learn more
              </Typography>
            </Typography>
          )}
        </Stack> */}
      </Stack>
    </Stack>
  );
};

export default BusinessPaymentsSettings;
